import { render, staticRenderFns } from "./Repairer.vue?vue&type=template&id=ba4b6e96&scoped=true&"
import script from "./Repairer.vue?vue&type=script&lang=js&"
export * from "./Repairer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4b6e96",
  null
  
)

export default component.exports